import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import ccIcon from '../assets/cc_icon.png';
import './SideNav.css';

interface SideNavProps {
  userRole?: number;
}

const SideNav: React.FC<SideNavProps> = ({ userRole = 1 }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = userRole === 4;
  const canUploadFiles = userRole > 1;

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="side-nav">
      <div className="nav-top">
        <Link to="/dashboard" className="nav-logo">
          <img src={ccIcon} alt="CC Logo" />
        </Link>
        
        <Link 
          to="/dashboard" 
          className={`nav-item ${location.pathname === '/dashboard' ? 'active' : ''}`}
        >
          <span className="material-icons">dashboard</span>
          <span className="tooltip">Dashboard</span>
        </Link>
        
        <Link 
          to="/kpi" 
          className={`nav-item ${location.pathname === '/kpi' ? 'active' : ''}`}
        >
          <span className="material-icons">trending_up</span>
          <span className="tooltip">KPI</span>
        </Link>

        {canUploadFiles && (
          <Link 
            to="/upload" 
            className={`nav-item ${location.pathname === '/upload' ? 'active' : ''}`}
          >
            <span className="material-icons">upload_file</span>
            <span className="tooltip">Subir Archivos</span>
          </Link>
        )}

        <Link 
          to={isAdmin ? '/admin-settings' : '/user-settings'} 
          className={`nav-item ${location.pathname.includes('settings') ? 'active' : ''}`}
        >
          <span className="material-icons">settings</span>
          <span className="tooltip">{isAdmin ? 'Admin Settings' : 'Settings'}</span>
        </Link>
      </div>

      <div className="nav-bottom">
        <button onClick={handleLogout} className="nav-item logout">
          <span className="material-icons">logout</span>
          <span className="tooltip">Cerrar Sesión</span>
        </button>
      </div>
    </nav>
  );
};

export default SideNav; 